import React from 'react'
import _ from 'lodash';
import { useBidderDataGetSaleBidderDataQuery } from '@sales/data/bidders/BidderDataQueries';
import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import { isLotInvoiced } from '@sales/data/lots/LotData';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import BidderActionMenu from '../menus/BidderActionMenu';
import BidderRegistrationDialog from '../../dialogs/BidderRegistrationDialog';
import { SaleContactGridLink } from '../../../contacts/components/buttons/SaleContactButtons';
import { isSaleBidderTheSame } from '@sales/data/bidders/BidderData';
import { useLotDataGetSaleLotDataQuery } from '@sales/data/lots/LotDataQueries';
import { useAgTechQueryResultCombination } from '@agtech/core/data/queries/AgTechDataQueries';
import { getContactFullName } from '@agtech/data/contacts/ContactData';

const BidderRegisteredBiddersGrid = () => {
    const bidderGridDataQuery = useBidderGridDataQuery();

    return (
        <AgTechGrid
            header={{
                title: 'Registered Bidders',
                content: () => <BidderRegistrationDialog.Button icon='fas fa-plus' text='Register new bidder' />
            }}
            data={{
                itemQuery: bidderGridDataQuery
            }}
            columns={[
                {
                    header: 'Bidder Number',
                    value: bidder => bidder.bidderNumber,
                    classes: 'centered bg-slate-100 emphasized',
                    width: '130px'
                },
                {
                    header: 'Name',
                    value: bidder => bidder.contact ? (
                        <SaleContactGridLink
                            contactId={bidder.contact.id}
                            contactName={getContactFullName(bidder.contact)}
                        />
                    ) : 'N/A'
                },
                {
                    header: 'Lots Purchased',
                    value: bidder => {
                        const lotsPurchasedByBidder = bidder.lots
                            .filter(lt => lt.originalBidderId === bidder.id && !isLotInvoiced(lt));

                        return (
                            <AgTechGridLink
                                content={lotsPurchasedByBidder.length.toString()}
                                // onHover={lotsPurchasedByBidder.length > 0 ? () => ({
                                //     popup: () => <BidderLotsListPopUp bidderId={bidder.bidderId} />,
                                //     config: {
                                        
                                //     }
                                // }) : undefined}
                                classes='px-2'
                            />
                        )
                    },
                    width: '120px',
                    classes: 'centered'
                },
                {
                    header: 'Lots Invoiced',
                    value: bidder => {
                        const invoicedLotsForbidder = bidder.lots
                            .filter(lt => lt.originalBidderId === bidder.id && isLotInvoiced(lt));

                        return (
                            <AgTechGridLink
                                content={invoicedLotsForbidder.length.toString()}
                                // onHover={lotsPurchasedByBidder.length > 0 ? () => ({
                                //     popup: () => <BidderLotsListPopUp bidderId={bidder.bidderId} />,
                                //     config: {
                                        
                                //     }
                                // }) : undefined}
                                classes='px-2'
                            />
                        ) 
                    },
                    width: '120px',
                    classes: 'centered'
                }
            ]}
            actions={{
                rendering: bidder => (
                    <BidderActionMenu.Button
                        bidderId={bidder.id}
                        bidderNumber={bidder.bidderNumber}
                    />
                )
            }}
            isRowEntityTheSame={(prev, curr) => {
                return isSaleBidderTheSame(prev, curr);
            }}
            searchConfig={{
                options: [
                    { field: 'Name', value: bidder => bidder.contact ? getContactFullName(bidder.contact) : ''},
                    { field: 'Bidder Number', value: bidder => bidder.bidderNumber ?? 'N/A'}
                ]
            }}
            sortingConfig={{
                getSortingKey: bidder => bidder.bidderNumber ?? 'N/A'
            }}
        />
    )
}

const useBidderGridDataQuery = () => {
    const lotsQuery = useLotDataGetSaleLotDataQuery();
    const bidderDataQuery = useBidderDataGetSaleBidderDataQuery();

    return useAgTechQueryResultCombination({
        firstQuery: lotsQuery,
        secondQuery: bidderDataQuery,
        projection: (lotData, bidderData) => {
            return {
                items: Object.values(bidderData.bidders).map(bidder => ({
                    ...bidder,
                    lots: Object.values(lotData.lots).filter(lt => bidder.id === lt.originalBidderId)
                })),
                context: {
                    lotData: lotData
                }
            }
        }
    })
}

export default BidderRegisteredBiddersGrid;